import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { IUserPostRequest, IUsersGetResponse, IUsersParams } from '../model/usersModel';
import {
  AddUsersAction,
  DeleteUsersAction,
  GetAllUsersAction,
  GetAllUsersSuccessAction,
  GetOneUsersSuccessAction,
  SetApiAllUsersRequestErrorAction,
  SetApiAllUsersRequestStateAction,
  SetApiUsersRequestErrorAction,
  SetApiUsersRequestStateAction,
  USERS_TYPES,
} from './usersTypes';

export const setApiAllUsersRequestState = (
  apiAllUsersRequestState: API_REQUEST_STATE,
): SetApiAllUsersRequestStateAction => ({
  type: USERS_TYPES.SET_API_ALL_USERS_REQUEST_STATE,
  payload: {
    apiAllUsersRequestState: apiAllUsersRequestState,
  },
});

export const setApiAllUsersRequestError = (apiUsersRequestError: string): SetApiAllUsersRequestErrorAction => ({
  type: USERS_TYPES.SET_API_ALL_USERS_REQUEST_ERROR,
  payload: {
    apiAllUsersRequestError: apiUsersRequestError,
  },
});

export const getAllUsersSuccess = (users: IUsersGetResponse[]): GetAllUsersSuccessAction => ({
  type: USERS_TYPES.GET_ALL_SUCCESS,
  payload: {
    users: users,
  },
});

export const setApiUsersRequestError = (apiUsersRequestError: string): SetApiUsersRequestErrorAction => ({
  type: USERS_TYPES.SET_API_USERS_REQUEST_ERROR,
  payload: {
    apiUsersRequestError: apiUsersRequestError,
  },
});

export const getAllUsers = (): GetAllUsersAction => ({
  type: USERS_TYPES.GET_ALL,
});

export const setApiUsersRequestState = (apiUsersRequestState: API_REQUEST_STATE): SetApiUsersRequestStateAction => ({
  type: USERS_TYPES.SET_API_USERS_REQUEST_STATE,
  payload: {
    apiUsersRequestState: apiUsersRequestState,
  },
});

export const getOneUsersSuccess = (users: IUsersGetResponse): GetOneUsersSuccessAction => ({
  type: USERS_TYPES.GET_ONE_SUCCESS,
  payload: {
    users: users,
  },
});

export const addUsers = (users: IUserPostRequest): AddUsersAction => ({
  type: USERS_TYPES.ADD,
  payload: {
    users: users,
  },
});

export const deleteUsers = (params: IUsersParams): DeleteUsersAction => ({
  type: USERS_TYPES.DELETE,
  payload: {
    params: {
      id: params.id,
    },
  },
});
